"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/stylesheets"),
    removeStylesheet = _require.removeStylesheet,
    createStylesheet = _require.createStylesheet;

var _require2 = require("../helpers/document-base-url"),
    documentBaseURL = _require2.documentBaseURL;

var _require3 = require("../helpers/text"),
    childTextContent = _require3.childTextContent;

var _require4 = require("../helpers/strings"),
    asciiCaseInsensitiveMatch = _require4.asciiCaseInsensitiveMatch;

var HTMLStyleElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLStyleElementImpl, _HTMLElementImpl);

  function HTMLStyleElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLStyleElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLStyleElementImpl).call(this, args, privateData));
    _this.sheet = null;
    _this._isOnStackOfOpenElements = false;
    return _this;
  }

  _createClass(HTMLStyleElementImpl, [{
    key: "_attach",
    value: function _attach() {
      _get(_getPrototypeOf(HTMLStyleElementImpl.prototype), "_attach", this).call(this);

      if (!this._isOnStackOfOpenElements) {
        this._updateAStyleBlock();
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      _get(_getPrototypeOf(HTMLStyleElementImpl.prototype), "_detach", this).call(this);

      if (!this._isOnStackOfOpenElements) {
        this._updateAStyleBlock();
      }
    }
  }, {
    key: "_childTextContentChangeSteps",
    value: function _childTextContentChangeSteps() {
      _get(_getPrototypeOf(HTMLStyleElementImpl.prototype), "_childTextContentChangeSteps", this).call(this); // This guard is not required by the spec, but should be unobservable (since you can't run script during the middle
      // of parsing a <style> element) and saves a bunch of unnecessary work.


      if (!this._isOnStackOfOpenElements) {
        this._updateAStyleBlock();
      }
    }
  }, {
    key: "_poppedOffStackOfOpenElements",
    value: function _poppedOffStackOfOpenElements() {
      this._isOnStackOfOpenElements = false;

      this._updateAStyleBlock();
    }
  }, {
    key: "_pushedOnStackOfOpenElements",
    value: function _pushedOnStackOfOpenElements() {
      this._isOnStackOfOpenElements = true;
    }
  }, {
    key: "_updateAStyleBlock",
    value: function _updateAStyleBlock() {
      if (this.sheet) {
        removeStylesheet(this.sheet, this);
      } // Browsing-context connected, per https://github.com/whatwg/html/issues/4547


      if (!this.isConnected || !this._ownerDocument._defaultView) {
        return;
      }

      var type = this.getAttributeNS(null, "type");

      if (type !== null && type !== "" && !asciiCaseInsensitiveMatch(type, "text/css")) {
        return;
      } // Not implemented: CSP


      var content = childTextContent(this); // Not implemented: a bunch of other state, e.g. title/media attributes

      createStylesheet(content, this, documentBaseURL(this._ownerDocument));
    }
  }]);

  return HTMLStyleElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLStyleElementImpl
};